import styles from "./guidance.module.css";

/**
 * Renders guidance.hero — copy and tone only; no derivation.
 *
 * @param {{
 *   hero?: { eyebrow?: string, title?: string, subtitle?: string | null, tone?: string } | null,
 *   children?: import('react').ReactNode,
 * }} props
 */
export default function ContextualHero({ hero, children }) {
  if (!hero?.title) return null;
  const tone = hero.tone || "neutral";

  return (
    <header
      className={styles.hero}
      data-tone={tone}
      data-testid="guidance-contextual-hero"
    >
      <div className={styles.heroToneBar} aria-hidden />
      {hero.eyebrow ? <p className={styles.heroEyebrow}>{hero.eyebrow}</p> : null}
      <h2 className={styles.heroTitle}>{hero.title}</h2>
      {hero.subtitle ? <p className={styles.heroSubtitle}>{hero.subtitle}</p> : null}
      {children}
    </header>
  );
}
